import React from 'react';

import { LoginModal, MergeModal, LogoutConfirmationModal,CreatePasswordModal } from './components';

import container from './LoginRoot.container';

const LoginRoot = (props) => {
  const {
    loginState,
    userState: { firstName },
    onHideLoginModal,
    onMergeAccounts,
    onHideMergeModal,
    onHideLogoutConfirmationModal,
    onFbLoginStart,
    onGoogleLoginStart,
    onLogoutStart,
    onShowSnackbarNotification,
    onHideGeneratePasswordModal
  } = props;

  return (
    <div>
      <LoginModal
        open={loginState.isLoginModalVisible}
        handleClose={onHideLoginModal}
        onFbLoginStart={onFbLoginStart}
        onGoogleLoginStart={onGoogleLoginStart}
      />
      <MergeModal
        open={loginState.isMergeModalVisible}
        handleClose={onHideMergeModal}
        onSubmit={onMergeAccounts}
        firstName={firstName}
      />
      <LogoutConfirmationModal
        onHideLogoutConfirmationModal={onHideLogoutConfirmationModal}
        onLogoutStart={onLogoutStart}
        onShowSnackbarNotification={onShowSnackbarNotification}
        open={loginState.isLogoutConfirmationVisible}
      />

      <CreatePasswordModal open={false} handleClose={onHideGeneratePasswordModal} provider={loginState.loginProvider} authedUid={loginState.authedUid}/>
    </div>
  );
};

export default container(LoginRoot);
